export const addMinutes = (minutes) => {
    return new Date(new Date().getTime() + minutes * 60000);
};